import React from "react";
import { Box, Divider } from "@mui/material";
import MUITypography from "../../Components/MUITypography";
import FeatureCard from "./FeatureCard";
import { landing_features } from "../../Util/ConstnatUtils";
import { VM_Colors } from "../../Styles/VMStyles";

const FeaturesSection = () => {
  return (
    <Box
      component="section"
      sx={{
        backgroundColor: VM_Colors.white,
        py: { xs: 6, md: 10 },
        position: "relative",
      }}
    >
      {/* Header */}
      <Box textAlign="center" mb={6}>
        <MUITypography
          variant="h2"
          fontWeight={700}
          sx={{
            color: VM_Colors.primary || "#0f172a",
            fontSize: { xs: 26, md: 36 },
          }}
        >
          Our Features
        </MUITypography>

        <Divider
          sx={{
            width: "80%",
            height: 4,
            mx: "auto",
            mt: 2,
            borderRadius: 2,
            background:
              "linear-gradient(to right, #f59e0b, #22d3ee)",
          }}
        />
        
      </Box>

      {/* Vertical Timeline Line */}
      <Box
        sx={{
          position: "absolute",
          top: 160,
          bottom: 80,
          left: "50%",
          width: "2px",
          background:
            "linear-gradient(to bottom, transparent, #e5e7eb, transparent)",
          transform: "translateX(-50%)",
          display: { xs: "none", md: "block" },
        }}
      />

      {/* Features */}
      <Box maxWidth="lg" sx={{ mx: "auto" }}>
        {landing_features.map((feature, index) => (
          <FeatureCard
            key={feature.title}
            index={index}
            {...feature}
          />
        ))}
      </Box>
    </Box>
  );
};

export default FeaturesSection;
